import React from 'react';
import './buttons.css'

const Button = (props) => {
  return ( 
    <button className={props.btnstyle} type='button'>
      <div className='button_hover_circle'></div>
      <div className='button_label_stack'>
        <div className='button_label'>
          {props.btnimg && <img src={props.btnimg} alt="" />}
          <div>{props.btntext}</div>
        </div>
        <div className='button_label_hover'>
          {props.btnimg && <img src={props.btnimg} alt="" />}
          <div>{props.btntext}</div>
        </div>
      </div>
    </button>
   );
}
 
export default Button;
